import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./components/Home.js";
import About from "./components/About.js";
import HireMe from "./components/Hireme.js";
import Project from "./components/Project.js";
function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/hireme" element={<HireMe />} />
      <Route path="/project" element={<Project />} />
    </Routes>
  </BrowserRouter>
  );
}

export default App;
